import { call, put } from 'redux-saga/effects'

import stripXprops from 'apps/lib/stripXprops'
import zoidTagFromPathname from 'common/tags/zoidTagFromPathname'
import createZoidChild from 'apps/lib/createZoidChild'
import { creators } from '../actions'

function* init({
    dispatch,
}, {
    payload: {
        pathname,
    },
}) {
    try {
        const tag = zoidTagFromPathname(pathname)

        try {
            yield call(createZoidChild, {
                tag,
                url: `https://${process.env.HOSTNAME}${pathname}/`,
            })
        } catch (error) {
            // zoid.create can only run once
        }

        if (!window.xprops) {
            throw new Error(`xprops for ${tag} not defined`)
        }

        const initXprops = stripXprops(window.xprops)

        window.xprops.onProps((props) => {
            const newXprops = stripXprops(props)

            dispatch(creators.onProps({
                payload: {
                    tag,
                    xprops: newXprops,
                },
            }))
        })

        yield put(
            yield call(
                creators.initSuccess,
                {
                    payload: {
                        tag,
                        xprops: initXprops,
                    },
                },
            ),
        )
    } catch (error) {
        yield put(
            yield call(
                creators.initError,
                {
                    error: error.message,
                },
            ),
        )
    }
}

export default init
